import { render } from "./ProductInfo.vue?vue&type=template&id=40f85912&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=40f85912&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f85912"]])

export default __exports__